module.exports = __webpack_public_path__ + "static/media/pluginTutorial.9ef96daa.mp4";